import React, { useState } from 'react';
import { useTheme } from '../App';
import { Link } from 'react-router-dom';
import { ArrowLeft, Save } from 'lucide-react';
const SettingsPage = () => {
  const {
    isDarkMode
  } = useTheme();
  // State for settings values
  const [settings, setSettings] = useState({
    auditAge: 30,
    dohMaxTarget: 21,
    dohMinThreshold: 5,
    fohInventoryLocation: 'Floor',
    fohReset: false,
    bohResetLocation: 'Safe',
    morningStockinTarget: 4
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    setSettings({
      ...settings,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : type === 'number' ? parseInt(value) : value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Save settings logic would go here
    alert('Settings saved successfully!');
  };
  return <div className={`min-h-screen ${isDarkMode ? 'bg-[#161c22] text-white' : 'bg-[#f9fafb] text-black'}`} data-id="element-476">
      <header className={`sticky top-0 z-50 ${isDarkMode ? 'bg-[#222930]' : 'bg-[#fefefe]'} shadow-md`} data-id="element-477">
        <div className="container mx-auto px-4 py-3 flex items-center" data-id="element-478">
          <Link to="/" className="flex items-center text-[#10b77f]" data-id="element-479">
            <ArrowLeft size={20} className="mr-2" data-id="element-480" />
            Back to Dashboard
          </Link>
          <h1 className="text-xl font-bold mx-auto" data-id="element-481">Settings</h1>
        </div>
      </header>
      <div className="container mx-auto px-4 py-6 max-w-3xl" data-id="element-482">
        <div className={`rounded-lg overflow-hidden ${isDarkMode ? 'bg-[#222930]' : 'bg-white'} shadow-lg`} data-id="element-483">
          <div className="p-6" data-id="element-484">
            <h2 className="text-2xl font-bold mb-6" data-id="element-485">BLAZE Ops Settings</h2>
            <form onSubmit={handleSubmit} data-id="element-486">
              <div className="space-y-6" data-id="element-487">
                {/* Audit Age */}
                <div data-id="element-488">
                  <label className="block font-medium mb-1" data-id="element-489">
                    Audit Age (days)
                  </label>
                  <p className="text-sm opacity-70 mb-2" data-id="element-490">
                    Max days since last inventory audit
                  </p>
                  <input type="number" name="auditAge" value={settings.auditAge} onChange={handleChange} className={`w-full p-2 rounded-md border ${isDarkMode ? 'bg-[#161c22] border-gray-700' : 'bg-white border-gray-300'}`} data-id="element-491" />
                </div>
                {/* DOH Max Target */}
                <div data-id="element-492">
                  <label className="block font-medium mb-1" data-id="element-493">
                    DOH Max Target
                  </label>
                  <p className="text-sm opacity-70 mb-2" data-id="element-494">
                    Max days of inventory you want on hand post-reorder
                  </p>
                  <input type="number" name="dohMaxTarget" value={settings.dohMaxTarget} onChange={handleChange} className={`w-full p-2 rounded-md border ${isDarkMode ? 'bg-[#161c22] border-gray-700' : 'bg-white border-gray-300'}`} data-id="element-495" />
                </div>
                {/* DOH Min Threshold */}
                <div data-id="element-496">
                  <label className="block font-medium mb-1" data-id="element-497">
                    DOH Min Threshold
                  </label>
                  <p className="text-sm opacity-70 mb-2" data-id="element-498">
                    Minimum safe days of inventory before reorder arrives
                  </p>
                  <input type="number" name="dohMinThreshold" value={settings.dohMinThreshold} onChange={handleChange} className={`w-full p-2 rounded-md border ${isDarkMode ? 'bg-[#161c22] border-gray-700' : 'bg-white border-gray-300'}`} data-id="element-499" />
                </div>
                {/* FOH Inventory Location */}
                <div data-id="element-500">
                  <label className="block font-medium mb-1" data-id="element-501">
                    FOH Inventory Location
                  </label>
                  <p className="text-sm opacity-70 mb-2" data-id="element-502">
                    Front of House Inventory Location
                  </p>
                  <select name="fohInventoryLocation" value={settings.fohInventoryLocation} onChange={handleChange} className={`w-full p-2 rounded-md border ${isDarkMode ? 'bg-[#161c22] border-gray-700' : 'bg-white border-gray-300'}`} data-id="element-503">
                    <option value="Counter" data-id="element-504">Counter</option>
                    <option value="Floor" data-id="element-505">Floor</option>
                    <option value="Display" data-id="element-506">Display</option>
                  </select>
                </div>
                {/* FOH Reset */}
                <div data-id="element-507">
                  <label className="block font-medium mb-1" data-id="element-508">FOH Reset</label>
                  <p className="text-sm opacity-70 mb-2" data-id="element-509">
                    Is FOH inventory reset nightly
                  </p>
                  <div className="flex items-center" data-id="element-510">
                    <input type="checkbox" name="fohReset" checked={settings.fohReset} onChange={handleChange} className="mr-2 rounded" data-id="element-511" />
                    <span data-id="element-512">{settings.fohReset ? 'Yes' : 'No'}</span>
                  </div>
                </div>
                {/* BOH Reset Location */}
                <div data-id="element-513">
                  <label className="block font-medium mb-1" data-id="element-514">
                    BOH Reset Location
                  </label>
                  <p className="text-sm opacity-70 mb-2" data-id="element-515">
                    Location to which inventory would be reset
                  </p>
                  <select name="bohResetLocation" value={settings.bohResetLocation} onChange={handleChange} className={`w-full p-2 rounded-md border ${isDarkMode ? 'bg-[#161c22] border-gray-700' : 'bg-white border-gray-300'}`} data-id="element-516">
                    <option value="Safe" data-id="element-517">Safe</option>
                    <option value="Vault" data-id="element-518">Vault</option>
                    <option value="Back Room" data-id="element-519">Back Room</option>
                  </select>
                </div>
                {/* Morning Stockin Target */}
                <div data-id="element-520">
                  <label className="block font-medium mb-1" data-id="element-521">
                    Morning Stockin Target
                  </label>
                  <p className="text-sm opacity-70 mb-2" data-id="element-522">
                    Target hours of coverage for morning transfer (if reset)
                  </p>
                  <input type="number" name="morningStockinTarget" value={settings.morningStockinTarget} onChange={handleChange} className={`w-full p-2 rounded-md border ${isDarkMode ? 'bg-[#161c22] border-gray-700' : 'bg-white border-gray-300'}`} data-id="element-523" />
                </div>
                <div className="flex justify-end space-x-3 pt-4" data-id="element-524">
                  <Link to="/" className={`px-4 py-2 rounded-md ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'}`} data-id="element-525">
                    Cancel
                  </Link>
                  <button type="submit" className="px-4 py-2 bg-[#10b77f] text-white rounded-md hover:bg-[#0ea271] transition-colors flex items-center" data-id="element-526">
                    <Save size={18} className="mr-2" data-id="element-527" />
                    Save Changes
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
};
export default SettingsPage;